import type { Result } from '@schibsted-nmp/search-frontend-clients/suggest';
import React from 'react';
import { trackResultClick } from '../suggest/tracking';
import { ResultGroup } from './ResultGroup';
import { ResultHits } from './ResultHits';
import { ResultInfo } from './ResultInfo';
import { ResultOption } from './ResultOption';
import { ResultTitle } from './ResultTitle';
import {
    SelectAction,
    type ActionFunction,
    type ResultsProps,
} from './ResultTypes';

export const companyProfileResultsAction: ActionFunction = ({
    metaData,
    result,
}) => {
    trackResultClick(result, metaData.tracking);
    window.location.href = result.url;
    return SelectAction.CLOSE;
};

export function CompanyProfileResults(props: ResultsProps) {
    const { headingClass, resultGroup } = props;

    const resultId = React.useId();

    return (
        <ResultGroup
            heading={resultGroup.groupingHeader}
            headingClass={headingClass}
        >
            {resultGroup.results.map((result) => {
                const imageSrc = getImageSrc(result);

                return (
                    <ResultOption
                        className="my-4"
                        linkClass="flex items-center space-x-8"
                        key={`${result.resultType}-${result.order}-${resultId}`}
                        result={result}
                    >
                        {imageSrc && (
                            <img
                                className="h-full shrink-0 max-h-full p-4"
                                src={imageSrc}
                                width="100"
                            />
                        )}
                        <div className="overflow-auto">
                            <ResultTitle result={result} />
                            {' ' /* intentional whitespace */}
                            <ResultHits result={result} />
                            <ResultInfo result={result} />
                        </div>
                    </ResultOption>
                );
            })}
        </ResultGroup>
    );
}

function getImageSrc(result: Result): string | undefined {
    return result.imgUrl?.replace('640w', '240w');
}
